<template>
  <div v-if="userDataLoad" id="common-header">
    <img
      src="/img/simple-modal-treed.svg"
      alt="logo"
      width="28"
      height="28"
      class="mr-3"
    />

    <h1 v-for="(tab, index) in filterTabList" class="d-flex" :key="index">
      <span
        @click="selectTab(tab)"
        :class="{
          'h1-active-text': isActive(tab),
          'h1-text': !isActive(tab),
        }"
      >
        {{ tab }}
      </span>

      <div
        v-if="index !== filterTabList.length - 1"
        class="ml-5 mr-5 line-css"
      ></div>
    </h1>

    <div style="margin-left: auto" class="d-flex">
      <!-- userInfo -->
      <div class="mr-5" style="margin-top: 3px">
        <span class="name tc-333" :title="userName">
          {{ userName }}
        </span>

        <span
          class="role tc-999 ml-1"
          v-if="userData.role !== 'R04' && userData.role !== 'R05'"
        >
          {{
            userData.role === "R01"
              ? "admin"
              : userData.roleNm
              ? userData.roleNm.toLowerCase()
              : ""
          }}
        </span>
        <span class="email ml-1" :title="userData.email">
          {{ userData.email }}
        </span>
      </div>

      <!-- alarm -->
      <div
        class="notification-icon d-flex align-center justify-center mr-5"
        @click="openNotificationModal"
        v-ripple
      >
        <img
          src="/img/notice.svg"
          alt="icon-notification"
          width="25"
          height="25"
        />
        <div v-if="alarmNew" class="dot"></div>
      </div>

      <!-- myPage -->
      <div
        class="d-flex align-center mr-5"
        @click="myPage"
        style="cursor: pointer"
      >
        <img
          src="/img/default-icon.svg"
          alt="icon-logout"
          class="mr-1"
          width="18"
          height="18"
        />
        <span class="t-caption b-text">My</span>
      </div>
      <!-- logout -->
      <div class="d-flex align-center" @click="logout" style="cursor: pointer">
        <img
          src="/img/Group 2.svg"
          alt="icon-logout"
          class="mr-1"
          width="18"
          height="18"
        />
        <span class="t-caption b-text">Logout</span>
      </div>
    </div>
    <!-- alarm modal -->
    <notification-modal :open.sync="notificationModal" />

    <CSimpleModal
      :open.sync="simpleModalOptions.open"
      width="650px"
      :iconShow="simpleModalOptions.iconShow"
      :lottieShow="simpleModalOptions.lottieShow"
      :btnShow="simpleModalOptions.btnShow"
      :positiveBtnOptions="simpleModalOptions.positiveBtnOptions"
      :negativeBtnOptions="simpleModalOptions.negativeBtnOptions"
      @submit="simpleModalOptions.submitFn"
    >
      {{ simpleModalOptions.content }}
    </CSimpleModal>
  </div>
</template>

<script>
// import { iUser } from "@/services";
import Util from "@/common/util";
import CSimpleModal from "@/components/designSystem/CSimpleModal.vue";
import NotificationModal from "@/views/Notification/NotificationModal.vue";

export default {
  name: "CommonHeader",
  props: {},
  components: {
    NotificationModal,
    CSimpleModal,
  },
  watch: {},
  data: () => {
    return {
      notificationModal: false, // 알람 모달
      activeTab: "",
      tabList: ["PROJECT", "ADMIN"], // methods 이름이랑 동일하게 추가해야 함
      userDataLoad: false,
      simpleModalOptions: {
        open: false,
        content: ``,
        iconShow: false,
        lottieShow: false,
        btnShow: true,
        positiveBtnOptions: { text: "확인" },
        negativeBtnOptions: { text: "취소" },
        submitFn: () => {},
      },
      passPageList: [
        "/profile",
        "/settlements",
        "/requestpapers",
        "/priceSetting",
      ],
    };
  },
  mounted() {
    if (this.$store.getters.auth.token) {
      this.getCurrentUserData();
    }
  },
  computed: {
    alarmNew() {
      return this.$store.state.alarm.alarmNew;
    },
    projectId() {
      // 이전 페이지의 projectID 값
      return this.$store.state.history.globalConst.projectId;
    },
    taskId() {
      return this.$route.query.taskId;
    },
    dashboardTab() {
      // 이전 페이지의 Tab 값 (DashBoard)
      return this.$store.state.history.globalConst.dashboardTab;
    },
    commonHeaderTab() {
      // 새로고침 시 Tab 값 (commonHeader)
      return this.$store.state.history.globalConst.commonHeaderTab;
    },
    filterTabList() {
      // ADMIN 탭이 제거된 새로운 tabList 반환
      if (this.userData.role === "R04" || this.userData.role === "R05") {
        return this.tabList.filter((tab) => tab !== "ADMIN");
      }
      return this.tabList;
    },
    userName() {
      return this.$store.state.auth.userData.name;
    },
    priceCheck() {
      // 단가 설정 화면에서 사용자가 이동 시 변경 된 데이터가 있을 경우 체크
      return (
        this.$store.state.history.globalConst.priceDataChange?.fileChange ||
        this.$store.state.history.globalConst.priceDataChange?.classChange
      );
    },
    userData() {
      return this.$store.state.auth.userData;
    },
  },
  methods: {
    async getCurrentUserData() {
      this.activeTab = this.commonHeaderTab;
      this.userDataLoad = true;
    },
    // 로그아웃
    async logout() {
      await this.$store.dispatch("alarm/stopAlarmCount");
      await this.$store.dispatch("auth/logOut");
      this.$store.commit("history/clearHistory");
      this.$store.commit("dashboard/clearDashboard");
      this.$store.commit("common/setLogoutState", false);
      // 로그인 페이지 마이그레이션 작업
      // this.$router.push("/login").catch();
      window.location.href = "/login";
    },
    // 마이페이지
    myPage() {
      if (!this.taskTabCheck("profile")) {
        return;
      }

      if (this.$route.path === "/profile") {
        return;
      }
      window.location.href = "/profile";
    },
    // 알람 모달 open
    openNotificationModal() {
      this.notificationModal = true;
    },
    project() {
      const url = Util.getDashboardUrl("/" + this.dashboardTab, this.projectId);

      window.location.href = `/dashboard${url}`;
    },
    admin() {
      window.location.href = "/admin/user";
    },
    isActive(tab) {
      return this.activeTab === tab;
    },
    selectTab(tab) {
      if (!this.taskTabCheck(tab)) {
        return;
      }

      if (this.passPageList.includes(this.$route.path)) {
        this.pageRouter(tab);
        return;
      }

      if (this.activeTab === tab) {
        return;
      }

      this.pageRouter(tab);
    },
    pageRouter(tab) {
      this.$store.commit("history/setCommonHeaderTab", tab);
      this.activeTab = tab;

      this[tab.toLowerCase()]();
    },
    taskTabCheck(path) {
      if (this.$route.path === "/task") {
        this.onCancelClick(path, "작업을 만들지 않고 나가시겠습니까?");
        return false;
      } else if (this.$route.path === "/priceSetting") {
        if (this.priceCheck) {
          this.onCancelClick(path, "변경 내용을 저장하지 않고 나가겠습니까?");
          return false;
        }
        return true;
      }
      return true;
    },
    onCancelClick(path, content) {
      this.simpleModalOptions.open = true;
      this.simpleModalOptions.content = content;
      this.simpleModalOptions.positiveBtnOptions.text = "나가기";
      this.simpleModalOptions.submitFn = () => this.cancelTask(path);
    },
    cancelTask(path) {
      if (this.$route.path === "/task") {
        this.$store.commit("task/clearTaskData");
        this.$store.commit("interface/clearInterface");
      }

      if (this.$route.path === "/priceSetting") {
        this.$store.commit("history/setFileChange", false);
        this.$store.commit("history/setClassChange", false);
      }

      this.activeTab = path === "profile" ? "PROJECT" : path;

      if (path === "PROJECT") {
        this.project();
        this.simpleModalOptions.open = false;
        return;
      }

      this.$router.push("/" + path);
      this.simpleModalOptions.open = false;
    },
  },
};
</script>

<style scoped>
#common-header {
  height: 60px;
  background-color: white;
  display: flex;
  align-items: center;
  padding: 0 24px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 60;
  border-bottom: 1px solid #0085cf;
}

.h1-active-text {
  font-size: 30px;
  font-weight: 900;
  color: #0085cf;
  cursor: pointer;
}

.h1-text {
  color: white;
  font-size: 30px;
  font-weight: 900;
  -webkit-text-stroke: 1px #a0c8e6;
  cursor: pointer;
}

.b-text {
  color: var(--primary-p-blue00, #0085cf);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18.6px;
}

.name {
  max-width: 150px;
  font-size: 17px;
  font-weight: 500;
}

.email {
  width: 230px;
}

.notification-icon {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  user-select: none;
  cursor: pointer;
  transform: translateX(5px);
}

.notification-icon .dot {
  position: absolute;
  right: -1px;
  top: -1px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #c83c50;
}

.line-css {
  width: 1px;
  height: 20px;
  background: #a0c8e6;
  padding: 14px 0px;
}
</style>
